<ng-container *ngIf="currentProperty as property">
	<!-- ===================================================== -->
	<!-- Shared dashboard period selector                       -->
	<!-- ===================================================== -->

	<!-- ===================================================== -->
	<!-- PMS-INTEGRATED PROPERTY                                -->
	<!-- ===================================================== -->

	<ng-container
		*ngIf="property.propertyPmsResponse?.isActive; else nonPmsDashboard"
	>
		<div class="dashboard-period">
			<app-dashboard-period-selector
				[propertyId]="property.id"
				[propertyTimezone]="dashboardPropertyTimezone"
				(periodChanged)="onDashboardPeriodChanged($event)"
			></app-dashboard-period-selector>
		</div>

		<div class="pms-dashboard-grid">
			<!-- ========================= -->
			<!-- COLUMN 1                  -->
			<!-- ========================= -->

			<div class="pms-dashboard-column">
				<app-dashboard-revenue-summary></app-dashboard-revenue-summary>

				<app-dashboard-risk-summary
					[periodLabel]="dashboardPeriodLabel"
					[summary]="dashboardData?.riskSummary ?? null"
					[dataStatus]="dashboardData?.context?.pmsDataStatus ?? null"
					[loading]="isLoadingDashboard"
					[error]="dashboardLoadError"
					[startDate]="dashboardStartDate"
					[endDate]="dashboardEndDate"
					(viewTask)="goToDashboardRiskTask($event)"
					(viewReport)="openRiskBreakdownDrawer($event)"
				></app-dashboard-risk-summary>

				<app-dashboard-auto-completed-tasks
					[autoCompletion]="dashboardData?.autoCompletion ?? null"
					[multiDay]="showRiskTrend"
					[loading]="isLoadingDashboard"
					[error]="dashboardLoadError"
					(viewTask)="goToDashboardRiskTask($event)"
					[periodLabel]="dashboardPeriodLabel"
					(viewBreakdown)="openAutoCompletionBreakdownDrawer($event)"
				></app-dashboard-auto-completed-tasks>
			</div>

			<!-- ========================= -->
			<!-- COLUMN 2                  -->
			<!-- ========================= -->

			<div class="pms-dashboard-column">
				<app-dashboard-audit-summary
					[summary]="dashboardData?.auditSummary ?? null"
					[dataStatus]="dashboardData?.context?.pmsDataStatus ?? null"
					[loading]="isLoadingDashboard"
					[error]="dashboardLoadError"
				></app-dashboard-audit-summary>

				<app-dashboard-task-actions-summary
					[unclaimedCount]="filteredTasks.length"
					[outstandingCount]="outstandingTasksCount"
					[followUpCount]="followUpCount"
					[isClaiming]="isClaimingUnclaimedTasks"
					(claimAll)="claimAllUnclaimedTasks()"
					(reviewTasks)="goToOutstandingTasks()"
					(expandUnclaimed)="openUnclaimedTasksDialog()"
					(viewFollowUps)="openFollowUpsDrawer()"
				></app-dashboard-task-actions-summary>

				<app-dashboard-mentions-summary
					[mentions]="dashboardMentions"
					(viewMention)="goToDashboardMention($event)"
					(viewAll)="openMentionsDrawer()"
				></app-dashboard-mentions-summary>

				<app-my-claimed-tasks></app-my-claimed-tasks>
			</div>

			<!-- ========================= -->
			<!-- COLUMN 3                  -->
			<!-- ========================= -->

			<div class="pms-dashboard-column">
				<app-dashboard-risk-trend
					*ngIf="showRiskTrend"
					[trend]="dashboardData?.riskTrend ?? null"
					[loading]="isLoadingDashboard"
					[error]="dashboardLoadError"
				></app-dashboard-risk-trend>

				<app-dashboard-tasks
					[tasks]="dashboardTasks"
					[loading]="isLoadingDashboardTasks"
					[error]="dashboardTasksLoadError"
				></app-dashboard-tasks>

				<app-dashboard-team
					[team]="dashboardTeam"
					[loading]="isLoadingDashboardTeam"
					[error]="dashboardTeamLoadError"
				></app-dashboard-team>

			</div>
		</div>

		<!-- ================================================= -->
		<!-- PMS RIGHT-SIDE DRAWERS                            -->
		<!-- ================================================= -->

		<div
			*ngIf="activeDashboardDrawer"
			class="dashboard-drawer-backdrop"
			(click)="closeDashboardDrawer()"
		>
			<aside
				class="dashboard-drawer"
				[class.dashboard-drawer-followups]="
		activeDashboardDrawer === 'followups'
	"
				role="dialog"
				aria-modal="true"
				(click)="$event.stopPropagation()"
			>
				<div class="dashboard-drawer-header">
					<div>
						<h3
							*ngIf="activeDashboardDrawer === 'unclaimed'"
							class="dashboard-drawer-title"
						>
							Unclaimed Tasks - {{ filteredTasks.length }}
						</h3>

						<h3
							*ngIf="activeDashboardDrawer === 'mentions'"
							class="dashboard-drawer-title"
						>
							Mentions - {{ mentionCount }}
						</h3>

						<h3
							*ngIf="
		activeDashboardDrawer === 'risk' &&
		selectedRiskReport
	"
							class="dashboard-drawer-title"
						>
							{{ selectedRiskReport.reportTypeName }} - Risk Breakdown
						</h3>

						<h3
							*ngIf="activeDashboardDrawer === 'autoCompletion'"
							class="dashboard-drawer-title"
						>
							{{ selectedAutoCompletionReportTypeName }} - Auto-Completed Tasks
						</h3>

						<h3
							*ngIf="activeDashboardDrawer === 'followups'"
							class="dashboard-drawer-title"
						>
							Follow Ups - {{ followUpCount }}
						</h3>
					</div>

					<button
						type="button"
						class="dashboard-drawer-close"
						aria-label="Close panel"
						(click)="closeDashboardDrawer()"
					>
						<i class="pi pi-times"></i>
					</button>
				</div>

				<div class="dashboard-drawer-content">
					<app-unclaimed-tasks
						*ngIf="activeDashboardDrawer === 'unclaimed'"
						[unclaimedTasks]="filteredTasks"
						[isLoading]="isLoadingUnclaimedTasks"
						[isClaiming]="isClaimingUnclaimedTasks"
						(claimTasksEvent)="claimTasks($event)"
					></app-unclaimed-tasks>

					<app-my-mentions
						*ngIf="activeDashboardDrawer === 'mentions'"
					></app-my-mentions>

					<app-dashboard-risk-breakdown
						*ngIf="
		activeDashboardDrawer === 'risk' &&
		selectedRiskReport
	"
						[report]="selectedRiskReport"
						(viewTask)="openDashboardRiskTaskInNewTab($event)"
					></app-dashboard-risk-breakdown>

					<app-my-follow-ups
						*ngIf="activeDashboardDrawer === 'followups'"
					></app-my-follow-ups>

					<app-dashboard-auto-completion-breakdown
						*ngIf="activeDashboardDrawer === 'autoCompletion'"
						[autoCompletion]="dashboardData?.autoCompletion ?? null"
						[reportTypeCode]="selectedAutoCompletionReportTypeCode"
						(viewTask)="openDashboardRiskTaskInNewTab($event)"
					></app-dashboard-auto-completion-breakdown>
				</div>
			</aside>
		</div>
	</ng-container>

	<!-- ===================================================== -->
	<!-- NON-PMS PROPERTY                                      -->
	<!-- ===================================================== -->

	<ng-template #nonPmsDashboard>
		<div class="non-pms-dashboard-grid">
			<!-- ========================= -->
			<!-- LEFT COLUMN               -->
			<!-- ========================= -->

			<div class="non-pms-dashboard-column">
				<app-dashboard-tasks
					[tasks]="dashboardTasks"
					[loading]="isLoadingDashboardTasks"
					[error]="dashboardTasksLoadError"
				></app-dashboard-tasks>

				<app-dashboard-team
					[team]="dashboardTeam"
					[loading]="isLoadingDashboardTeam"
					[error]="dashboardTeamLoadError"
				></app-dashboard-team>

				<app-my-claimed-tasks></app-my-claimed-tasks>
			</div>

			<!-- ========================= -->
			<!-- RIGHT COLUMN              -->
			<!-- Existing operational UI   -->
			<!-- ========================= -->

			<div class="non-pms-dashboard-column">
				<div class="card dashboard-widget-navigation">
					<app-top-widget-panel
						(widgetClick)="handleWidgetClick($event)"
						[activeWidget]="activeTab"
						[followUpCount]="followUpCount"
						[mentionCount]="mentionCount"
						[outstandingCount]="outstandingTasksCount"
						[unclaimedCount]="unclaimedTasks.length"
					></app-top-widget-panel>
				</div>

				<div
					class="card dashboard-operational-panel"
					[ngClass]="{
		'dashboard-operational-panel-followups': activeTab === 'followups'
	}"
				>
					<div
						*ngIf="activeTab === 'unclaimed'"
						class="dashboard-operational-heading"
					>
						<h4>
							Unclaimed Tasks - {{ unclaimedTasks.length }}
						</h4>
					</div>

					<div
						*ngIf="activeTab === 'followups'"
						class="dashboard-operational-heading"
					>
						<h4>
							Follow Ups - {{ followUpCount }}
						</h4>
					</div>

					<div
						*ngIf="activeTab === 'mentions'"
						class="dashboard-operational-heading"
					>
						<h4>
							Mentions - {{ mentionCount }}
						</h4>
					</div>

					<div *ngIf="activeTab === 'unclaimed'">
						<app-unclaimed-tasks
							[unclaimedTasks]="filteredTasks"
							[isLoading]="isLoadingUnclaimedTasks"
							[isClaiming]="isClaimingUnclaimedTasks"
							(claimTasksEvent)="claimTasks($event)"
						></app-unclaimed-tasks>
					</div>

					<div *ngIf="activeTab === 'followups'">
						<app-my-follow-ups></app-my-follow-ups>
					</div>

					<div *ngIf="activeTab === 'mentions'">
						<app-my-mentions></app-my-mentions>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</ng-container>
